export default __webpack_public_path__ + "static/media/home-restaurant-img-04.154a1169.png";